import { omitBy } from "lodash-es"

const emptyValues = [undefined, null, ""] as const

export function cleanObject<T extends Record<string, any>>(object: T) {
  return omitBy<T>(object, (value) => emptyValues.includes(value))
}
